
import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { yesNoOptions } from '../../../utils/mics';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';

const SysEventsFilterForm = ({ handleSearch, handleReset, onFormValuesChange }) => {

    const dispatch = useDispatch();

    const filters = useSelector((state) => state.sysEvents.filters);

    const formik= useFormik (

        {
            initialValues :{
                storeId: filters?.storeId || '',
                metaDataType: filters?.metaDataType || '',
                cmdType: filters?.cmdType || '',
                cmdValidity: filters?.cmdValidity || '',
                cmdDate: filters?.cmdDate || '',
                cmdTime: filters?.cmdTime || '',
                processed: filters?.processed || null,
                processedOn: filters?.processedOn || null,
                date_from : filters?.date_from || '',
                date_till : filters?.date_till || ''
            },       

        onSubmit : (values) => {
            const data = {
                ...values,
                date_from: values.date_from ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
                cmdDate: values.cmdDate ? moment(values.cmdDate).format('YYYY-MM-DD') : '',
                cmdTime: values.cmdTime ? moment(values.cmdTime).format('HH:mm:ss') : '',
                processedOn: values.processedOn ? moment(values.processedOn).format('YYYY-MM-DD') : '',
            };
            dispatch(appActions.SYSEVENTS_SET_FILTERS_REQUEST(values));
            handleSearch(data);
            if (onFormValuesChange) {
                onFormValuesChange(data);
            }
        },
    });

    const handleClear = () => {
        dispatch(appActions.SYSEVENTS_SET_FILTERS_REQUEST({}));
        formik.resetForm();
        onFormValuesChange(null);
        handleReset();
    };

    const handleChange = (e) => {

        formik.handleChange(e);
        if (onFormValuesChange) {
            const values = { ...formik.values, [e.target.name]: e.target.value };
            const data = {
                ...values,
                date_from: values.date_from ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
                cmdDate: values.cmdDate ? moment(values.cmdDate).format('YYYY-MM-DD') : '',
                cmdTime: values.cmdTime ? moment(values.cmdTime).format('HH:mm:ss') : '',
                processedOn: values.processedOn ? moment(values.processedOn).format('YYYY-MM-DD') : '',
            };
            onFormValuesChange(data);
        }

    }

    const isDateTillUpdated = useRef(false); // Track if update is needed

    useEffect(() => {
        if (
            formik.values.date_from &&
            (!formik.values.date_till || new Date(formik.values.date_till) < new Date(formik.values.date_from))
        ) {
            if (!isDateTillUpdated.current) { // Prevent infinite loop
                formik.setFieldValue("date_till", formik.values.date_from);
                isDateTillUpdated.current = true; // Mark as updated
            }
        } else {
            isDateTillUpdated.current = false; // Reset when update is not needed
        }
    }, [formik, formik.values.date_from]); // Only trigger when date_from changes

    const renderFormArea = () => {

        return (
            <>
                <div className="p-fluid formgrid grid w-full">

                    <div className="field col-12 md:col-3">
                        <label htmlFor="storeId">Store Id</label>
                        <InputText id="storeId" name="storeId" type="text" value={formik.values.storeId} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="cmdType">CMD Type</label>
                        <InputText id="cmdType" name="cmdType" type="text" value={formik.values.cmdType} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="cmdDate">CMD Date</label>
                        <Calendar id="cmdDate" name="cmdDate" value={formik.values.cmdDate} onChange={handleChange} dateFormat="dd-mm-yy" showIcon />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="cmdValidity">CMD Validity</label>
                        <InputText id="cmdValidity" name="cmdValidity" type="text" value={formik.values.cmdValidity} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Processed</label>
                        <Dropdown filter showClear  value={formik.values.processed} onChange={handleChange} options={yesNoOptions} id="processed" name="processed" optionLabel="name" optionValue='code' />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="processedOn">Processed On</label>
                        <Calendar id="processedOn" name="processedOn" value={formik.values.processedOn} onChange={handleChange} dateFormat="dd-mm-yy" showIcon />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date From</label>
                        <Calendar id="date_from" name="date_from" value={formik.values.date_from} onChange={handleChange} dateFormat="dd-mm-yy" showIcon maxDate={new Date()}/>
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_till">Date Till</label>
                        <Calendar id="date_till" name="date_till" value={formik.values.date_till} onChange={handleChange} dateFormat="dd-mm-yy" showIcon minDate={formik.values.date_from} />
                    </div>
                </div>
                <div className="grid px-2 py-4 flex-row-reverse gap-10">
                    <Button type="submit" icon="pi pi-search" label="Search" severity="success" outlined className="p-button-success mr-2 tp" data-pr-tooltip="Search" />
                    <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset Filter" label="Reset Filter" severity="secondary" outlined onClick={handleClear} />
                </div>
            </>
        );
    };

    return <form onSubmit={formik.handleSubmit}>{renderFormArea()}</form>;
}

export default SysEventsFilterForm;

